import { default as UserTeamsList } from './UserTeamsList';

export default UserTeamsList;
